import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";



@Component({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule
  ],
  selector: 'AdminMainTemplate',
  templateUrl: './MainTemplate.html',
  standalone: true,
  styleUrl: './MainTemplate.css'
})
export class AdminMainTemplate {

}
